module.exports = __webpack_public_path__ + "columns.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/columns.svg?color1=%233F51B5&color2=
// module id = 2192
// module chunks = 67